// import logo from './logo.png';
import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Routes, Route } from 'react-router-dom';
import Header from './Components/SiteComponents/Header';
import Footer from './Components/SiteComponents/Footer';
import { Container } from 'react-bootstrap';
import HomeScreen from './Screens/HomeScreen';



function App() {
  return (
    <div className="App">
      <Header/>
      <main>
        <Container>
          <HomeScreen />
        </Container>
      </main>
      <Footer />
    </div>
  );
}

export default App;
